import { FloorState } from 'src/types/redux';
import {
  FETCH_FLOOR_FAILURE,
  FETCH_FLOOR_REQUEST,
  FETCH_FLOOR_SUCCESS,
  FloorActionType,
} from '../types/floorType';

const initialState: FloorState = {
  error: '',
  loading: false,
  floorData: [],
};

export const floorReducer = (
  state = initialState,
  action: FloorActionType
): FloorState => {
  switch (action?.type) {
    case FETCH_FLOOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        floorData: action?.payload,
      };
    case FETCH_FLOOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
